
import { useEffect, useState } from "react";


import PromptDialog from "../../components/PromptDialog";


import { changeSettings } from "../../store/module/settins";
import { useDispatch, useSelector } from "react-redux";
import { apiGetNonce, apiWalletAuth } from "@/api/h5.js"
import { changeBscWalletAddress } from "../../store/module/h5Login";
import { Toast } from "react-vant";
// import bnbImg from "../../assets/images/wallet/binance.png"
// import metamaskImg from "../../assets/images/wallet/metamask.png"
// import { redirectToMetaMask, isMobile } from "../../utils/redirectToMetaMask"


// const BSC_CHAIN_ID = "0x38"; // BSC 主网的链 ID 为 56 (0x38 是16进制表示)
// const BSC_RPC_URL = "https://bsc-dataseed.binance.org/"; // BSC RPC URL
// const BSC_CHAIN_ID: any = "0x61"; // BSC 测试网的链 ID 为 97 (0x61 是16进制表示)
// const BSC_RPC_URL = "https://data-seed-prebsc-1-s1.binance.org:8545/"; // BSC 测试网 RPC URL


//wagmi
import { useAccount, useBalance, useConnections, useDisconnect, useSignMessage, useSwitchChain } from "wagmi"
import WalletBtn from "../wagmi/walletBtn";
import ButtonComp from "../../components/common/ButtonComp";
import { isShowSwitchChainHandler } from "../../store/module/h5.config";

import { useTranslation } from "react-i18next";


const useConnectBscWallet = () => {
    const { t, i18n } = useTranslation();
    const { address: account, isConnected, chain } = useAccount();
    const { disconnect } = useDisconnect()
    const connections = useConnections();
    const { switchChainAsync, switchChain } = useSwitchChain();
    const dispatch = useDispatch()
    const settings = useSelector((state: any) => state.settings.settings)
    // const { activate, deactivate, account, library, active, chainId } = useWeb3React()
    const { data: balanceData } = useBalance({
        address: account, // 用户地址
        unit: "ether",
    });


    const authWalletHandle = async () => {
        setShowBscSign(true)
    }
    // let toast: any = null
    const startSign = async () => {
        // toast = Toast.loading({
        //     message: 'Loading...',
        //     forbidClick: true,
        //     duration: 30000
        // });
        try {
            const { code, data: nonce } = await apiGetNonce(account)
            const message = `StarAI Authentication Request

This signature is required to verify your identity and create a secure connection. This is a standard Web3 authentication process that ensures only the rightful wallet owner can access the account.

Purpose:
- Account verification
- Secure authentication
- Identity confirmation

Security Notice:
- This request only verifies ownership
- No funds will be transferred
- No gas fees required
- No contract permissions granted

Nonce:${nonce}`;
            await signMessageHandle(message)

        } catch (e) {
            // toast.clear()
            setShowBscSign(false)
            disConnectHandle()
            console.log("🚀 ~ authWalletHandle ~ e:", e)

        }
    }
    const { signMessage, data } = useSignMessage({
        mutation: {
            onSuccess: async (signature) => {
                const token = await verifySignature(signature);
                setShowBscSign(false)
                // toast.clear()

                if (token) {
                    localStorage.setItem("address_params", account as string)
                    if (localStorage.getItem("token")) {
                        return
                    }
                    localStorage.setItem("userId", account as string)
                    localStorage.setItem("token", token)
                    dispatch(changeBscWalletAddress(account))
                    // window.location.href = "http://localhost:5173/";
                    window.location.href = import.meta.env.VITE_HREF;
                }
            },
            onError: (error) => {
                console.log("🚀 ~ handleSignMessage ~ error:", error)
            }
        }
    })

    const signMessageHandle = async (message: any) => {
        await signMessage({ message });
    };
    // 验证签名
    const verifySignature = async (signature: string) => {
        const params = {
            id: account,
            track_id: localStorage.getItem("track_id") || '',
            make_a_check_in_in_starai: localStorage.getItem("make_a_check_in_in_starai") || '',
            invitation_code: localStorage.getItem('startapp') || "",
            signature
        }
        const { code, data } = await apiWalletAuth(params)
        if (code == "0") {
            return data
        }

    };

    const [isShowBscConnectWallet, setShowConnectWallet] = useState(false)
    const [isShowBscSign, setShowBscSign] = useState(false)
    useEffect(() => {
        if (account && isConnected && !localStorage.getItem("token")) {
            const chainId = parseInt(import.meta.env.VITE_BSC_CHAIN_ID)
            switchChain({ chainId: chainId })
            setTimeout(() => {
                authWalletHandle()
            }, 300)
        }
        if (account && isConnected) {
            localStorage.setItem("userId", account as string)
            setShowConnectWallet(false)
        }
    }, [account, isConnected])



    const connectWalletBtn = () => {
        return (
            <>
                <WalletBtn></WalletBtn>
            </>
        )
    }


    const [bscSwitchChain, setBscSwitchChain] = useState(false)
    const bscConnectWallet = () => {
        return (
            <PromptDialog title={t("other.attention")} teleport={document.querySelector('body')} dialog={true} setDialog={() => {
                if (!account) {
                    dispatch(changeSettings({ ...settings, connect_wallet: false }))
                }
                setShowConnectWallet(false)

            }} isClose text={t("h5.connect_wallet")}>
                {connectWalletBtn()}
            </PromptDialog>
        )
    }
    const bscSwitchChainHandle = () => {
        return (
            <PromptDialog title={t("other.attention")} teleport={document.querySelector('body')} dialog={true} setDialog={() => {
                dispatch(isShowSwitchChainHandler(false))

            }} isClose text={t("h5.text11")}>
                <ButtonComp mt={20} title={t("other.cancel")} callBack={() => {
                    dispatch(isShowSwitchChainHandler(false))
                }}></ButtonComp>
                <ButtonComp mt={20} title={t("h5.switch")} callBack={() => {
                    const chainId = parseInt(import.meta.env.VITE_BSC_CHAIN_ID)
                    switchChainAsync({ chainId: chainId }).then(() => {
                        setTimeout(() => {
                            dispatch(isShowSwitchChainHandler(false))

                        }, 300)
                    })

                }}></ButtonComp>
            </PromptDialog>
        )
    }
    const disConnectHandle = () => {
        disconnect()
        dispatch(changeSettings({ ...settings, connect_wallet: false }))
    }
    return {
        isShowBscConnectWallet,
        bscConnectWallet,
        disConnectHandle,
        setShowConnectWallet,
        account,
        connectWalletBtn,
        authWalletHandle,
        setShowBscSign,
        isShowBscSign,
        startSign,
        balanceData,
        chain,
        bscSwitchChainHandle,
        setBscSwitchChain,
        bscSwitchChain
    }
}

export default useConnectBscWallet

